<template>
  <div class="h-100 border-right border-left border-light">
    <b-nav vertical class="text-dark supplier-nav-left sticky-top w-100 min-vh-100">
      <b-nav-item
        link-classes="py-4 border-bottom border-light text-dark d-flex"
        :to="{ name: 'home' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="17"
            viewBox="0 0 24 17"
            fill="#363636"
          >
            <path
              fill-rule="evenodd"
              d="M23.904,4.325 L23.118,3.249
          L23.905,2.164 C24.032,1.988 24.031,1.751 23.904,1.576 L22.904,0.206 C22.81,0.076 22.66,0
          22.5,0 L5.5,0 C4.673,0 4,0.673 4,1.5 L4,5 L1.5,5 C0.673,5 0,5.673 0,6.5 L0,15.5 C0,16.327
          0.673,17 1.5,17 L18.5,17 C18.66,17 18.811,16.923 18.904,16.793 L19.904,15.415
          C20.032,15.24 20.032,15.003 19.904,14.828 L19.118,13.743 L19.904,12.66 C20.032,12.485
          20.032,12.247 19.904,12.072 L19.852,12 L22.5,12 C22.66,12 22.811,11.923 22.905,11.793
          L23.905,10.413 C24.031,10.238 24.031,10.001 23.905,9.826 L23.118,8.741 L23.904,7.665
          C24.031,7.49 24.032,7.252 23.905,7.077 L23.118,5.992 L23.904,4.916 C24.032,4.739
          24.032,4.501 23.904,4.325 L23.904,4.325 Z M5,1.5 C5,1.224 5.225,1 5.5,1 L10,1 L10,5 L5,5
          L5,1.5 L5,1.5 Z M1,15.5 L1,6.5 C1,6.224 1.225,6 1.5,6 L6,6 L6,16 L1.5,16 C1.225,16
          1,15.776 1,15.5 L1,15.5 Z M18.096,14.037 L18.882,15.122 L18.245,16 L7,16 L7,6 L18.245,6
          L18.882,6.874 L18.096,7.952 C17.968,8.127 17.968,8.365 18.096,8.541 L18.882,9.62
          L18.096,10.7 C17.968,10.875 17.968,11.113 18.096,11.288 L18.882,12.367 L18.096,13.449
          C17.968,13.625 17.968,13.861 18.096,14.037 L18.096,14.037 Z M22.245,11 L19.123,11
          L19.118,10.994 L19.904,9.913 C20.032,9.738 20.032,9.5 19.904,9.325 L19.118,8.246
          L19.904,7.169 C20.032,6.994 20.032,6.756 19.904,6.58 L18.904,5.206 C18.811,5.077 18.66,5
          18.5,5 L11,5 L11,1 L22.246,1 L22.882,1.871 L22.095,2.956 C21.968,3.132 21.969,3.369
          22.096,3.544 L22.881,4.619 L22.096,5.694 C21.969,5.869 21.968,6.107 22.095,6.282
          L22.882,7.367 L22.096,8.443 C21.969,8.618 21.968,8.856 22.095,9.031 L22.883,10.117
          L22.245,11 L22.245,11 Z"
            />
          </svg>
        </div>
        <span>Verdibevis</span>
      </b-nav-item>
      <b-nav-item
        link-classes="py-4 border-bottom border-light text-dark d-flex w-100"
        :to="{ name: 'invoices' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="24"
            viewBox="0 0 16 24"
            fill="#363636"
          >
            <g fill-rule="evenodd" transform="translate(0 -1)">
              <path
                d="M0.735,24.941 L2.38,24.066 L4.025,24.941
            C4.098,24.98 4.179,25 4.259,25 C4.339,25 4.421,24.98 4.494,24.941 L6.136,24.066
            L7.773,24.94 C7.919,25.019 8.096,25.019 8.244,24.94 L9.884,24.065 L11.522,24.939
            C11.668,25.018 11.846,25.018 11.993,24.939 L13.627,24.065 L15.265,24.939 C15.42,25.022
            15.607,25.017 15.758,24.927 C15.908,24.838 16,24.676 16,24.5 L16,1.5 C16,1.324
            15.908,1.162 15.757,1.071 C15.606,0.981 15.42,0.975 15.265,1.058 L13.62,1.934
            L11.975,1.059 C11.829,0.981 11.652,0.981 11.505,1.059 L9.863,1.934 L8.226,1.06
            C8.08,0.981 7.903,0.981 7.755,1.06 L6.115,1.935 L4.479,1.059 C4.333,0.98 4.155,0.98
            4.008,1.059 L2.374,1.933 L0.735,1.059 C0.581,0.976 0.394,0.981 0.243,1.071 C0.092,1.162
            0,1.324 0,1.5 L0,24.5 C0,24.676 0.092,24.838 0.243,24.929 C0.393,25.019 0.578,25.023
            0.735,24.941 L0.735,24.941 Z M1,2.333 L2.138,2.94 C2.285,3.019 2.462,3.019 2.609,2.94
            L4.243,2.066 L5.881,2.94 C6.027,3.019 6.204,3.019 6.352,2.94 L7.992,2.065 L9.629,2.939
            C9.775,3.019 9.953,3.018 10.099,2.939 L11.741,2.064 L13.386,2.939 C13.532,3.017
            13.709,3.017 13.856,2.939 L15,2.333 L15,23.667 L13.862,23.06 C13.715,22.981
            13.538,22.981 13.391,23.06 L11.757,23.934 L10.119,23.06 C9.973,22.981 9.796,22.981
            9.648,23.06 L8.008,23.935 L6.371,23.061 C6.225,22.982 6.048,22.983 5.901,23.061
            L4.259,23.936 L2.614,23.061 C2.542,23.02 2.46,23 2.38,23 C2.3,23 2.218,23.02
            2.145,23.059 L1,23.667 L1,2.333 L1,2.333 Z"
              />
              <path
                d="M3.5 7L8.5 7C8.776 7 9 6.776 9 6.5 9 6.224 8.776 6
            8.5 6L3.5 6C3.224 6 3 6.224 3 6.5 3 6.776 3.224 7 3.5 7L3.5 7zM3.5 11L12.5 11C12.776 11
            13 10.776 13 10.5 13 10.224 12.776 10 12.5 10L3.5 10C3.224 10 3 10.224 3 10.5 3 10.776
            3.224 11 3.5 11L3.5 11zM3.5 14L12.5 14C12.776 14 13 13.776 13 13.5 13 13.224 12.776 13
            12.5 13L3.5 13C3.224 13 3 13.224 3 13.5 3 13.776 3.224 14 3.5 14L3.5 14zM3.5 17L12.5
            17C12.776 17 13 16.776 13 16.5 13 16.224 12.776 16 12.5 16L3.5 16C3.224 16 3 16.224 3
            16.5 3 16.776 3.224 17 3.5 17L3.5 17zM3.5 20L9.5 20C9.776 20 10 19.776 10 19.5 10 19.224
            9.776 19 9.5 19L3.5 19C3.224 19 3 19.224 3 19.5 3 19.776 3.224 20 3.5 20L3.5 20zM12.5
            19L11.5 19C11.224 19 11 19.224 11 19.5 11 19.776 11.224 20 11.5 20L12.5 20C12.776 20 13
            19.776 13 19.5 13 19.224 12.776 19 12.5 19L12.5 19z"
              />
            </g>
          </svg>
        </div>

        <span>Oppgjør</span>
        <b-badge variant="primary" pill class="small round">
          {{ nextInvoiceCount.length }}
        </b-badge>
      </b-nav-item>
      <b-nav-item
        v-if="user.supplier.booking_visible"
        link-classes="py-4 border-bottom border-light text-dark d-flex w-100"
        :to="{ name: 'bookings' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="#363636"
          >
            <g>
              <path
                d="M19.5833333,1.66666667 L16.6666667,1.66666667 L16.6666667,0.416666667 C16.6666667,0.186666667 16.48,0 16.25,0 C16.02,0 15.8333333,0.186666667 15.8333333,0.416666667 L15.8333333,1.66666667 L12.5,1.66666667 L12.5,0.416666667 C12.5,0.186666667 12.3133333,0 12.0833333,0 C11.8533333,0 11.6666667,0.186666667 11.6666667,0.416666667 L11.6666667,1.66666667 L8.33333333,1.66666667 L8.33333333,0.416666667 C8.33333333,0.186666667 8.14666667,0 7.91666667,0 C7.68666667,0 7.5,0.186666667 7.5,0.416666667 L7.5,1.66666667 L4.16666667,1.66666667 L4.16666667,0.416666667 C4.16666667,0.186666667 3.98,0 3.75,0 C3.52,0 3.33333333,0.186666667 3.33333333,0.416666667 L3.33333333,1.66666667 L0.416666667,1.66666667 C0.186666667,1.66666667 0,1.85333333 0,2.08333333 L0,17.9166667 C0,18.1466667 0.186666667,18.3333333 0.416666667,18.3333333 L19.5833333,18.3333333 C19.8133333,18.3333333 20,18.1466667 20,17.9166667 L20,2.08333333 C20,1.85333333 19.8133333,1.66666667 19.5833333,1.66666667 Z M3.33333333,2.5 L3.33333333,2.91666667 C3.33333333,3.14666667 3.52,3.33333333 3.75,3.33333333 C3.98,3.33333333 4.16666667,3.14666667 4.16666667,2.91666667 L4.16666667,2.5 L7.5,2.5 L7.5,2.91666667 C7.5,3.14666667 7.68666667,3.33333333 7.91666667,3.33333333 C8.14666667,3.33333333 8.33333333,3.14666667 8.33333333,2.91666667 L8.33333333,2.5 L11.6666667,2.5 L11.6666667,2.91666667 C11.6666667,3.14666667 11.8533333,3.33333333 12.0833333,3.33333333 C12.3133333,3.33333333 12.5,3.14666667 12.5,2.91666667 L12.5,2.5 L15.8333333,2.5 L15.8333333,2.91666667 C15.8333333,3.14666667 16.02,3.33333333 16.25,3.33333333 C16.48,3.33333333 16.6666667,3.14666667 16.6666667,2.91666667 L16.6666667,2.5 L19.1666667,2.5 L19.1666667,5 L0.833333333,5 L0.833333333,2.5 L3.33333333,2.5 Z M0.833333333,17.5 L0.833333333,5.83333333 L19.1666667,5.83333333 L19.1666667,17.5 L0.833333333,17.5 Z"
              ></path>
              <path
                d="M5.91666667 7L3.41666667 7C3.18666667 7 3 7.18666667 3 7.41666667L3 9.91666667C3 10.1466667 3.18666667 10.3333333 3.41666667 10.3333333L5.91666667 10.3333333C6.14666667 10.3333333 6.33333333 10.1466667 6.33333333 9.91666667L6.33333333 7.41666667C6.33333333 7.18666667 6.14666667 7 5.91666667 7zM5.5 9.5L3.83333333 9.5 3.83333333 7.83333333 5.5 7.83333333 5.5 9.5zM15.9166667 7L13.4166667 7C13.1866667 7 13 7.18666667 13 7.41666667L13 9.91666667C13 10.1466667 13.1866667 10.3333333 13.4166667 10.3333333L15.9166667 10.3333333C16.1466667 10.3333333 16.3333333 10.1466667 16.3333333 9.91666667L16.3333333 7.41666667C16.3333333 7.18666667 16.1466667 7 15.9166667 7zM15.5 9.5L13.8333333 9.5 13.8333333 7.83333333 15.5 7.83333333 15.5 9.5zM10.9166667 7L8.41666667 7C8.18666667 7 8 7.18666667 8 7.41666667L8 9.91666667C8 10.1466667 8.18666667 10.3333333 8.41666667 10.3333333L10.9166667 10.3333333C11.1466667 10.3333333 11.3333333 10.1466667 11.3333333 9.91666667L11.3333333 7.41666667C11.3333333 7.18666667 11.1466667 7 10.9166667 7zM10.5 9.5L8.83333333 9.5 8.83333333 7.83333333 10.5 7.83333333 10.5 9.5zM5.91666667 12L3.41666667 12C3.18666667 12 3 12.1866667 3 12.4166667L3 14.9166667C3 15.1466667 3.18666667 15.3333333 3.41666667 15.3333333L5.91666667 15.3333333C6.14666667 15.3333333 6.33333333 15.1466667 6.33333333 14.9166667L6.33333333 12.4166667C6.33333333 12.1866667 6.14666667 12 5.91666667 12zM5.5 14.5L3.83333333 14.5 3.83333333 12.8333333 5.5 12.8333333 5.5 14.5zM15.9166667 12L13.4166667 12C13.1866667 12 13 12.1866667 13 12.4166667L13 14.9166667C13 15.1466667 13.1866667 15.3333333 13.4166667 15.3333333L15.9166667 15.3333333C16.1466667 15.3333333 16.3333333 15.1466667 16.3333333 14.9166667L16.3333333 12.4166667C16.3333333 12.1866667 16.1466667 12 15.9166667 12zM15.5 14.5L13.8333333 14.5 13.8333333 12.8333333 15.5 12.8333333 15.5 14.5zM10.9166667 12L8.41666667 12C8.18666667 12 8 12.1866667 8 12.4166667L8 14.9166667C8 15.1466667 8.18666667 15.3333333 8.41666667 15.3333333L10.9166667 15.3333333C11.1466667 15.3333333 11.3333333 15.1466667 11.3333333 14.9166667L11.3333333 12.4166667C11.3333333 12.1866667 11.1466667 12 10.9166667 12zM10.5 14.5L8.83333333 14.5 8.83333333 12.8333333 10.5 12.8333333 10.5 14.5z"
              ></path>
            </g>
          </svg>
        </div>
        <span>Bookingsystem</span>
      </b-nav-item>
      <b-nav-item
        link-classes="py-4 border-bottom border-light text-dark d-flex w-100"
        :to="{ name: 'products' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="#363636"
          >
            <path
              d="M0.416666667,9.16718636 L1.66666667,9.16718636
          L1.66666667,19.583853 C1.66666667,19.813853 1.85333333,20.0005197 2.08333333,20.0005197
          L17.9166667,20.0005197 C18.1466667,20.0005197 18.3333333,19.813853 18.3333333,19.583853
          L18.3333333,9.16718636 L19.5833333,9.16718636 C19.8133333,9.16718636 20,8.98051969
          20,8.75051969 L20,5.41718636 C20,5.18718636 19.8133333,5.00051969 19.5833333,5.00051969
          L12.11,5.00051969 C12.7816667,4.72718636 13.92,4.15968636 14.5566667,3.24551969
          C14.9733333,2.64635302 15.0983333,1.98385302 14.92,1.32885302 C14.6908333,0.498853024
          13.8633333,-0.0711469761 12.9758333,0.00718635725 C11.395,0.143853024
          10.1516667,1.61885302 9.55416667,3.35051969 C9.01,2.02635302 8.01,0.947186357
          6.76333333,0.839686357 C5.9875,0.770519691 5.26833333,1.26885302 5.07,1.99135302
          C4.91333333,2.55801969 5.02166667,3.13051969 5.3825,3.64635302 C5.83416667,4.29551969
          6.5825,4.73718636 7.1475,5.00051969 L0.416666667,5.00051969 C0.186666667,5.00051969
          0,5.18718636 0,5.41718636 L0,8.75051969 C0,8.98051969 0.186666667,9.16718636
          0.416666667,9.16718636 Z M2.5,9.16718636 L8.33333333,9.16718636 L8.33333333,19.1671864
          L2.5,19.1671864 L2.5,9.16718636 Z M10.8333333,9.16718636 L10.8333333,19.1671864
          L9.16666667,19.1671864 L9.16666667,9.16718636 L10.8333333,9.16718636 Z M17.5,19.1671864
          L11.6666667,19.1671864 L11.6666667,9.16718636 L17.5,9.16718636 L17.5,19.1671864 Z
          M13.1291667,0.833853024 C13.5091667,0.833853024 13.98,1.05801969 14.1158333,1.54968636
          C14.2316667,1.96968636 14.1516667,2.36801969 13.8733333,2.76885302 C13.2825,3.61635302
          12.0066667,4.19051969 11.345,4.39551969 C10.7816667,4.56968636 10.3633333,4.69968636
          10.0541667,4.80218636 C10.3191667,2.91885302 11.5066667,0.971353024 13.1291667,0.833853024
          Z M6.06583333,3.17051969 C5.845,2.85551969 5.7825,2.54218636 5.87416667,2.21301969
          C5.97166667,1.85718636 6.32333333,1.66968636 6.68333333,1.66968636 C6.68666667,1.66968636
          6.68916667,1.66968636 6.69166667,1.66968636 C7.92,1.77635302 8.8625,3.29885302
          9.10666667,4.80635302 C8.85833333,4.72468636 8.54166667,4.62635302 8.13666667,4.49968636
          C7.59333333,4.33135302 6.54666667,3.86135302 6.06583333,3.17051969 Z
          M0.833333333,5.83385302 L9.5775,5.83385302 L9.58333333,5.83385302 L9.58916667,5.83385302
          L9.6,5.83385302 L19.1666667,5.83385302 L19.1666667,8.33385302 L17.9166667,8.33385302
          L2.08333333,8.33385302 L0.833333333,8.33385302 L0.833333333,5.83385302 Z"
            />
          </svg>
        </div>
        <span>Opplevelser</span></b-nav-item
      >
      <b-nav-item
        link-classes="py-4 border-bottom border-light text-dark d-flex w-100"
        :to="{ name: 'companyInfo' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#363636"
          >
            <g fill-rule="evenodd">
              <path
                d="M23.947,4.276 L21.947,0.276 C21.862,0.107 21.689,0
            21.5,0 L2.5,0 C2.311,0 2.138,0.107 2.053,0.276 L0.053,4.276 C0.051,4.281 0.051,4.286
            0.049,4.29 C0.019,4.354 0,4.424 0,4.5 L0,9.5 C0,9.776 0.224,10 0.5,10 C1.211,10
            1.659,9.643 2,9.242 L2,23.5 C2,23.776 2.224,24 2.5,24 L13.5,24 L19.5,24 L21.5,24
            C21.776,24 22,23.776 22,23.5 L22,9.24 C22.341,9.642 22.788,10 23.5,10 C23.776,10
            24,9.776 24,9.5 L24,4.5 C24,4.424 23.981,4.354 23.951,4.29 C23.949,4.286 23.949,4.281
            23.947,4.276 L23.947,4.276 Z M2.809,1 L21.192,1 L22.692,4 L1.309,4 L2.809,1 L2.809,1 Z
            M14,23 L14,14 L19,14 L19,23 L14,23 L14,23 Z M20,23 L20,13.5 C20,13.224 19.776,13 19.5,13
            L13.5,13 C13.224,13 13,13.224 13,13.5 L13,23 L3,23 L3,8.104 C3.113,8.043 3.233,8 3.38,8
            C3.822,8 4.05,8.286 4.413,8.792 C4.801,9.33 5.283,10 6.259,10 C7.235,10 7.716,9.33
            8.103,8.792 C8.466,8.286 8.693,8 9.134,8 C9.575,8 9.802,8.286 10.165,8.792 C10.552,9.33
            11.033,10 12.008,10 C12.984,10 13.465,9.33 13.852,8.792 C14.215,8.286 14.441,8 14.882,8
            C15.321,8 15.549,8.286 15.911,8.792 C16.298,9.33 16.778,10 17.752,10 C18.728,10
            19.209,9.33 19.596,8.792 C19.959,8.286 20.186,8 20.626,8 C20.771,8 20.889,8.041 21,8.101
            L21,23 L20,23 L20,23 Z M22.47,8.208 C22.298,7.969 22.104,7.706 21.86,7.485 C21.854,7.478
            21.847,7.473 21.84,7.467 C21.537,7.2 21.156,7 20.626,7 C19.651,7 19.17,7.67 18.783,8.208
            C18.42,8.714 18.193,9 17.752,9 C17.313,9 17.086,8.714 16.724,8.209 C16.337,7.67 15.856,7
            14.882,7 C13.908,7 13.426,7.67 13.039,8.208 C12.676,8.714 12.449,9 12.008,9 C11.568,9
            11.341,8.714 10.978,8.208 C10.591,7.67 10.109,7 9.134,7 C8.159,7 7.677,7.67 7.29,8.208
            C6.927,8.714 6.699,9 6.259,9 C5.817,9 5.589,8.714 5.226,8.208 C4.838,7.67 4.355,7 3.38,7
            C2.857,7 2.478,7.195 2.177,7.456 C2.162,7.469 2.147,7.481 2.134,7.495 C1.894,7.714
            1.703,7.972 1.533,8.208 C1.334,8.485 1.176,8.697 1,8.831 L1,5 L23,5 L23,8.83
            C22.826,8.695 22.668,8.485 22.47,8.208 L22.47,8.208 Z"
              />
              <path
                d="M11.5 13L4.5 13C4.224 13 4 13.224 4 13.5L4 18.5C4
            18.776 4.224 19 4.5 19L11.5 19C11.776 19 12 18.776 12 18.5L12 13.5C12 13.224 11.776 13
            11.5 13L11.5 13zM11 18L5 18 5 14 11 14 11 18 11 18zM17.5 17C17.224 17 17 17.224 17
            17.5L17 19.5C17 19.776 17.224 20 17.5 20 17.776 20 18 19.776 18 19.5L18 17.5C18 17.224
            17.776 17 17.5 17L17.5 17z"
              />
            </g>
          </svg>
        </div>
        <span>Bedriftsopplysninger</span>
      </b-nav-item>
      <b-nav-item
        link-classes="py-4 border-bottom border-light text-dark d-flex w-100"
        :to="{ name: 'userInfo' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#363636"
          >
            <path
              fill-rule="evenodd"
              d="M12,0 C5.383,0 0,5.383 0,12
          C0,14.977 1.101,17.831 3.098,20.035 C3.098,20.035 3.098,20.035 3.098,20.036 L3.099,20.037
          L3.099,20.037 L3.099,20.037 C5.371,22.555 8.615,24 12,24 C15.417,24 18.685,22.532
          20.963,19.973 C20.963,19.973 20.963,19.972 20.964,19.971 C22.922,17.775 24,14.944 24,12
          C24,5.383 18.617,0 12,0 L12,0 Z M12,23 C8.986,23 6.094,21.75 4.022,19.562 L4.768,16.678
          C4.983,15.706 5.943,15 7.05,15 L9.6,15 C10.372,15 11,14.372 11,13.546 C11,13.099
          10.778,12.678 10.391,12.392 C8.581,11.049 8.44,8.431 8.44,7.66 C8.44,5.197 9.591,4 11.96,4
          C14.369,4 15.59,5.231 15.59,7.66 C15.59,9.239 15.07,11.31 13.61,12.391 C13.222,12.678
          13,13.1 13,13.6 C13,14.372 13.628,15 14.4,15 L17.14,15 C18.247,15 19.206,15.706
          19.422,16.678 L20.046,19.495 C17.966,21.726 15.048,23 12,23 L12,23 Z M20.854,18.522
          L20.398,16.462 C20.078,15.012 18.738,14 17.14,14 L14.4,14 C14.179,14 14,13.82 14,13.547
          C14,13.366 14.143,13.241 14.205,13.195 C16.418,11.556 16.59,8.544 16.59,7.66 C16.59,4.699
          14.902,3 11.96,3 C9.045,3 7.44,4.655 7.44,7.66 C7.44,8.549 7.61,11.574 9.795,13.195
          C9.857,13.241 10,13.366 10,13.6 C10,13.82 9.82,14 9.6,14 L7.05,14 C5.452,14 4.112,15.012
          3.796,16.445 L3.232,18.627 C1.788,16.727 1,14.408 1,12 C1,5.935 5.935,1 12,1 C18.065,1
          23,5.935 23,12 C23,14.36 22.244,16.64 20.854,18.522 L20.854,18.522 Z"
            />
          </svg>
        </div>
        <span>Brukeropplysninger</span>
      </b-nav-item>
      <b-nav-text
        link-classes="py-4 border-bottom border-light text-dark d-flex"
        :to="{ name: 'home' }"
      >
        <div class="mt-2 mt-lg-5 px-3">
          <a href="#" @click.prevent="signOut" class="text-danger small">Logg ut</a>
          <div class="mt-3">
            <h6>Support</h6>
            <ul class="list-unstyled mt-2">
              <li>
                <svg
                  class="d-none d-lg-inline mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="#363636"
                >
                  <path
                    d="M15.976,0.213333333 C15.9666667,0.188666667 15.9513333,0.168666667 15.9366667,0.148 C15.928,0.135333333 15.924,0.120666667 15.9133333,0.108666667 C15.912,0.106666667 15.9093333,0.106 15.908,0.104666667 C15.8893333,0.0853333333 15.866,0.072 15.8433333,0.0573333333 C15.8293333,0.0486666667 15.8173333,0.036 15.802,0.0293333333 C15.7846667,0.022 15.7653333,0.0206666667 15.7466667,0.016 C15.7226667,0.01 15.6993333,0.002 15.6753333,0.00133333333 C15.672,0.00133333333 15.6693333,0 15.6666667,0 L0.333333333,0 C0.330666667,0 0.328666667,0.00133333333 0.326,0.00133333333 C0.302,0.002 0.28,0.01 0.256666667,0.0153333333 C0.237333333,0.02 0.216666667,0.0213333333 0.198,0.03 C0.185333333,0.0353333333 0.174666667,0.0466666667 0.162,0.054 C0.137333333,0.0693333333 0.112666667,0.084 0.0926666667,0.104666667 C0.0913333333,0.106666667 0.0886666667,0.106666667 0.0873333333,0.108666667 C0.0766666667,0.120666667 0.0726666667,0.135333333 0.064,0.148 C0.0493333333,0.169333333 0.0333333333,0.189333333 0.024,0.213333333 C0.0153333333,0.236666667 0.0133333333,0.261333333 0.00933333333,0.286 C0.00733333333,0.302 0,0.316666667 0,0.333333333 L0,11.6666667 C0,11.8506667 0.149333333,12 0.333333333,12 L15.6666667,12 C15.8506667,12 16,11.8506667 16,11.6666667 L16,0.333333333 C16,0.316666667 15.9926667,0.302 15.9906667,0.286 C15.9866667,0.261333333 15.9846667,0.236666667 15.976,0.213333333 Z M14.8073333,0.666666667 L8,6.882 L1.19266667,0.666666667 L14.8073333,0.666666667 Z M0.666666667,11.3333333 L0.666666667,1.08866667 L7.77533333,7.57933333 C7.83933333,7.63733333 7.91933333,7.66666667 8,7.66666667 C8.08066667,7.66666667 8.16066667,7.63733333 8.22466667,7.57933333 L15.3333333,1.08866667 L15.3333333,11.3333333 L0.666666667,11.3333333 Z"
                  />
                </svg>
                <a class="font-weight-light" href="mailto: support@youwish.no"
                  ><span>support@youwish.no</span></a
                >
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  class="d-none d-lg-inline mr-2"
                >
                  <g fill="#363636">
                    <path
                      d="M.396666667 8.09733333C1.064 9.39466667 2.05666667 10.778 3.192 11.9913333 4.14933333 13.014 5.22933333 13.9193333 6.40133333 14.6813333L6.566 14.7886667C7.43533333 15.3566667 8.42 16 9.56066667 16 9.56133333 16 9.58066667 16 9.58133333 16 10.5273333 15.9933333 11.454 15.6066667 12.1233333 14.9373333L13.0453333 14.0166667C13.4286667 13.6326667 13.4286667 13.008 13.0453333 12.624L11.2033333 10.7826667C10.8313333 10.4106667 10.1826667 10.41 9.81066667 10.7826667L8.622 11.9706667C8.516 12.0766667 8.33533333 12.096 8.21533333 12.0133333 6.55666667 10.8653333 5.13266667 9.442 3.984 7.78333333 3.89933333 7.66066667 3.91733333 7.486 4.02666667 7.37666667L5.21533333 6.18866667C5.40133333 6.00266667 5.504 5.75533333 5.504 5.49266667 5.504 5.22933333 5.40133333 4.982 5.21533333 4.79666667L3.37266667 2.95466667C3 2.584 2.352 2.58333333 1.98 2.95466667L1.05866667 3.876C.891333333 4.04333333.738666667 4.22866667.606666667 4.42733333-.114 5.504-.196 6.94533333.396666667 8.09733333zM1.16066667 4.79733333C1.26933333 4.63533333 1.39333333 4.484 1.53 4.34733333L2.45133333 3.42666667C2.51133333 3.36666667 2.59133333 3.33333333 2.67666667 3.33333333 2.762 3.33333333 2.842 3.36666667 2.90133333 3.42666667L4.744 5.26866667C4.804 5.32866667 4.83733333 5.408 4.83733333 5.49333333 4.83733333 5.57866667 4.804 5.658 4.744 5.718L3.55533333 6.906C3.216 7.24533333 3.166 7.774 3.43533333 8.16333333 4.63 9.888 6.11 11.368 7.83533333 12.562 7.998 12.6746667 8.18933333 12.734 8.38866667 12.734 8.65133333 12.734 8.908 12.6273333 9.09333333 12.442L10.282 11.254C10.4026667 11.1333333 10.6113333 11.1333333 10.732 11.254L12.574 13.0953333C12.698 13.2193333 12.698 13.4213333 12.574 13.5453333L11.6526667 14.466C11.1066667 15.012 10.35 15.328 9.57733333 15.3333333L9.56133333 15.6666667 9.56133333 15.3333333C8.61933333 15.3333333 7.76133333 14.7726667 6.93133333 14.2306667L6.76533333 14.122C5.638 13.3893333 4.59933333 12.5193333 3.67933333 11.536 2.58466667 10.3666667 1.63 9.03733333.99 7.79266667.506 6.852.572666667 5.67666667 1.16066667 4.79733333zM9.33333333 0C9.14933333 0 9 .149333333 9 .333333333 9 .517333333 9.14933333.666666667 9.33333333.666666667 12.6413333.666666667 15.3333333 3.35866667 15.3333333 6.66666667 15.3333333 6.85066667 15.4826667 7 15.6666667 7 15.8506667 7 16 6.85066667 16 6.66666667 16 2.99066667 13.0093333 0 9.33333333 0z"
                    />
                    <path
                      d="M13.3333333,6.66666667 C13.3333333,6.85066667 13.4826667,7 13.6666667,7 C13.8506667,7 14,6.85066667 14,6.66666667 C14,4.09333333 11.9066667,2 9.33333333,2 C9.14933333,2 9,2.14933333 9,2.33333333 C9,2.51733333 9.14933333,2.66666667 9.33333333,2.66666667 C11.5393333,2.66666667 13.3333333,4.46066667 13.3333333,6.66666667 Z"
                    />
                    <path
                      d="M9,4.33333333 C9,4.51733333 9.14933333,4.66666667 9.33333333,4.66666667 C10.436,4.66666667 11.3333333,5.564 11.3333333,6.66666667 C11.3333333,6.85066667 11.4826667,7 11.6666667,7 C11.8506667,7 12,6.85066667 12,6.66666667 C12,5.196 10.804,4 9.33333333,4 C9.14933333,4 9,4.14933333 9,4.33333333 Z"
                    />
                  </g>
                </svg>

                <span class="font-weight-light">22 33 33 40</span>
              </li>
            </ul>
            <p class="mt-2 font-weight-light text-small">
              YouWish.no sin kundeservice er åpen alle hverdager. Vi svarer vanligvis på e-post innen fire timer i åpningstiden.
            </p>

            <h6>Åpningstider</h6>
            <div class="row">
              <div class="col-md-4">Mandag:</div>
              <div class="col-md-4">11–14</div>
            </div>
            <div class="row">
              <div class="col-md-4">Tirsdag:</div>
              <div class="col-md-4">11–14</div>
            </div>
            <div class="row">
              <div class="col-md-4">Onsdag:</div>
              <div class="col-md-4">11–13</div>
            </div>
            <div class="row">
              <div class="col-md-4">Torsdag:</div>
              <div class="col-md-4">13–15</div>
            </div>
            <div class="row">
              <div class="col-md-4">Fredag:</div>
              <div class="col-md-4">13–15</div>
            </div>

          </div>
        </div>
      </b-nav-text>
    </b-nav>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: 'sidebar',
  data() {
    return {
      currentRoute: 'home',
    };
  },
  computed: {
    ...mapGetters({
      nextInvoiceCount: 'invoices/canBeInvoicedTable',
      user: 'auth/getUser',
    }),
  },
  methods: {
    ...mapMutations({
      logout: 'auth/logout',
    }),
    signOut() {
      this.logout();
      this.$router.push({ name: 'login' });
    },
  },
  watch: {
    $route: function(to, from) {
      this.currentRoute = to;
    },
  },
};
</script>
